import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { SpinnerOverlayComponent } from '../components/shared/spinner-overlay/spinner-overlay.component';

@Injectable()
export class SpinnerService {

    private messageSubject = new BehaviorSubject<boolean>(false);
    // eslint-disable-next-line @typescript-eslint/member-ordering
    public message$ = this.messageSubject.asObservable();

    private overlayRef: OverlayRef | null = null;

    constructor(private overlay: Overlay) {}
     
    show(): void {
       if (!this.overlayRef) {
            this.overlayRef = this.overlay.create({
                hasBackdrop: true,
                backdropClass: 'spinner-backdrop',
                panelClass: 'spinner-cdk-panel',
                scrollStrategy: this.overlay.scrollStrategies.block(),
                positionStrategy: this.overlay.position()
                .global()
                .centerHorizontally()
                .centerVertically()
            });
        }

        if (!this.overlayRef.hasAttached()) {
            this.overlayRef.attach(new ComponentPortal(SpinnerOverlayComponent));
        }
    }

    hide(): void {
       if (this.overlayRef) {
            this.overlayRef.detach();
        }
    }

    next(show: boolean): void {
        if (show === true) {
            this.show();
        } else {
            this.hide();
        }
    }

}
